import SSRModel from '../../../models/secure/SSRModel';

const getSubscriptionInfo = async (context, payload) => {
    let ssrModel = new SSRModel();
    return ssrModel.getSubscriptionInfo(payload).then(res => {
        let commitTarget = (res.data && res.data.status == SSRModel.STATUS_SUCCESS) ? 'SET_SUBSCRIPTION_INFO' : 'CLEAR_SUBSCRIPTION_INFO';
        context.commit(commitTarget, res.data.records);
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const getSubscriptionDetail = async (context, payload) => {
    let ssrModel = new SSRModel();
    return ssrModel.getSubscriptionDetail(payload).then(res => {
        let commitTarget = (res.data && res.data.status == SSRModel.STATUS_SUCCESS) ? 'SET_SUBSCRIPTION_DETAIL' : 'CLEAR_SUBSCRIPTION_DETAIL';
        context.commit(commitTarget, res.data.records);
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const getProblematicRecords = async (context, payload) => {
    let ssrModel = new SSRModel();
    return ssrModel.getProblematicRecords(payload).then(res => {
        let commitTarget = (res.data && res.data.status == SSRModel.STATUS_SUCCESS) ? 'SET_SUBSCRIPTION_RECORDS' : 'CLEAR_SUBSCRIPTION_RECORDS';
        context.commit(commitTarget, res.data.records);
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const updateProblematicRecord = async (context, payload) => {
    let ssrModel = new SSRModel();
    return ssrModel.updateProblematicRecord(payload).then(res => {
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const ssrEnabled = async (context, payload) => {
    let ssrModel = new SSRModel();
    return ssrModel.ssrEnabled(payload).then(res => {
        return res.data;
    }).catch(err => {
        return {
            status: "ERROR",
            description: err + " - Failed to connect to server"
        };
    });
}

const clearSubscriptionInfo = (context) => {
    context.commit('CLEAR_SUBSCRIPTION_INFO');
};

const clearSubscriptionDetail = (context) => {
    context.commit('CLEAR_SUBSCRIPTION_DETAIL');
};

const clearStates = (context) => {
    context.commit('CLEAR_STATES');
};

export {
    getSubscriptionInfo,
    getSubscriptionDetail,
    getProblematicRecords,
    updateProblematicRecord,
    ssrEnabled,
    clearSubscriptionInfo,
    clearSubscriptionDetail,
    clearStates
}
